const VERSION_PATTERN = /^\d+(\.\d+)*$/;

export const isValidVersion = (value: unknown): value is string =>
	typeof value === 'string' && VERSION_PATTERN.test(value);

/** Negative when `a < b`, zero when equal, positive when `a > b`; missing parts count as 0. */
export const compareVersions = (a: string, b: string): number => {
	const partsA = a.split('.').map(Number);
	const partsB = b.split('.').map(Number);
	const length = Math.max(partsA.length, partsB.length);
	for (let index = 0; index < length; index += 1) {
		const difference = (partsA[index] ?? 0) - (partsB[index] ?? 0);
		if (difference !== 0) return difference;
	}
	return 0;
};
